import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { InfoIncon } from '../../../Inputs/info';
import { ConsiderationModal } from '../../ConsiderationModal';
import { ButtonWrapper } from '../../ConsiderationModal/styles';
import { ConsideracaoIcon } from '../../../Inputs/consideracao';
import { Container, ListIconWrapper, SvgContainer } from './styled';
import { Dialog, DialogContent, DialogTitle, Tooltip, DialogActions } from '@mui/material';

import { Svg_001 } from './svgs/001-dollar';
import { Svg_002 } from './svgs/002-email';
import { Svg_003 } from './svgs/003-clipboard';
import { Svg_004 } from './svgs/004-wallet';
import { Svg_005 } from './svgs/005-address';
import { Svg_006 } from './svgs/006-coins';
import { Svg_007 } from './svgs/007-bank';

import { PlansService } from '@/services/endpoints/plans';
import { Svg_008 } from './svgs/008-reading';
import { Svg_009 } from './svgs/009-donut';
import { Svg_010 } from './svgs/010-money';
import { Svg_011 } from './svgs/011-education';
import { Svg_012 } from './svgs/012-online';
import { Svg_013 } from './svgs/013_dollar'
import { Svg_014 } from './svgs/014_folder'
import { Svg_015 } from './svgs/015_link';
import { Svg_016 } from './svgs/016_box';
import { Svg_017 } from './svgs/017_invoice';
import { Svg_018 } from './svgs/018_highlight';
import { Svg_019 } from './svgs/019_location';
import { Svg_020 } from './svgs/020_profit';
import { Svg_021 } from './svgs/021_calendar';
import { Svg_022 } from './svgs/022_coin';
import { Svg_023 } from './svgs/023_money';
import { Svg_024 } from './svgs/024_mr';
import { Svg_025 } from './svgs/025_banking';
import { Svg_026 } from './svgs/026_dollar';
import { Svg_027 } from './svgs/027_certificate';
import { Svg_028 } from './svgs/028_secure';
import { Svg_029 } from './svgs/029_skills';
import { Svg_030 } from './svgs/030_coins';
import { Svg_031 } from './svgs/031_atm';
import { Svg_032 } from './svgs/032_website';
import { Svg_033 } from './svgs/033_award';
import { Svg_034 } from './svgs/034_credit';
import { Svg_035 } from './svgs/035_job';
import { Svg_036 } from './svgs/036_fax';
import { Svg_037 } from './svgs/037_purse';
import { Svg_038 } from './svgs/038_calculator';
import { Svg_039 } from './svgs/039_mrs';
import { Svg_040 } from './svgs/040_briefcase';
import { Svg_041 } from './svgs/041_laptop';
import { Svg_042 } from './svgs/042_goal';
import { Svg_043 } from './svgs/043_resume';
import { Svg_044 } from './svgs/044_money';
import { Svg_045 } from './svgs/045_telephone';
import { Svg_046 } from './svgs/046_career';
import { Svg_047 } from './svgs/047_transfer';
import { Svg_048 } from './svgs/048_school';
import { Svg_049 } from './svgs/049_bitcoin';
import { Svg_050 } from './svgs/050_movie';
import { Svg_051 } from './svgs/051_growth';
import { Svg_052 } from './svgs/052_volunteering';
import { Svg_053 } from './svgs/053_register';
import { Svg_054 } from './svgs/054_check';
import { Svg_055 } from './svgs/055_agenda';
import { Svg_056 } from './svgs/056_portfolio';
import { Svg_057 } from './svgs/057_investment';
import { Svg_058 } from './svgs/058_business';
import { Svg_059 } from './svgs/059_recommendation';
import { Svg_060 } from './svgs/060_internship';
import { Svg_061 } from './svgs/061_career';
import { Svg_062 } from './svgs/062_willing';
import { Svg_063 } from './svgs/063_hiring';
import { Svg_064 } from './svgs/064_driving';
import { Svg_065 } from './svgs/065_publications';
import { Svg_066 } from './svgs/066_profile';
import { Svg_067 } from './svgs/067_computer';
import { Svg_068 } from './svgs/068_goals';
import { Svg_069 } from './svgs/069_training';
import { Svg_070 } from './svgs/070_salary';
import { Svg_071 } from './svgs/071_music';
import { Svg_072 } from './svgs/072_achievement';
import { Svg_073 } from './svgs/073_cross';
import { Svg_074 } from './svgs/074_website';
import { Svg_075 } from './svgs/075_stamp';
import { ACCESS } from '@/utils/enviroments';
import { Svg_076 } from './svgs/076';
import { Svg_077 } from './svgs/077';
import { Svg_078 } from './svgs/078';
import { Svg_079 } from './svgs/079';
import { Svg_080 } from './svgs/080';
import { Svg_081 } from './svgs/081';
import { Svg_082 } from './svgs/082';
import { Svg_083 } from './svgs/083';
import { Svg_084 } from './svgs/084';
import { Svg_085 } from './svgs/085';
import { Svg_086 } from './svgs/086';
import { Svg_087 } from './svgs/087';
import { Svg_088 } from './svgs/088';
import { Svg_089 } from './svgs/089';
import { Svg_090 } from './svgs/090';
import { Svg_091 } from './svgs/091';
import { Svg_092 } from './svgs/092';
import { Svg_093 } from './svgs/093';
import { Svg_094 } from './svgs/94';
import { Svg_095 } from './svgs/95';
import { Svg_096 } from './svgs/96';
import { Svg_097 } from './svgs/97';
import { Svg_098 } from './svgs/98';
import { Svg_099 } from './svgs/99';
import { Svg_100 } from './svgs/100';
import { Svg_101 } from './svgs/101';
import { Svg_102 } from './svgs/102';
import { Svg_103 } from './svgs/103';
import { Svg_104 } from './svgs/104';
import { Svg_105 } from './svgs/105';
import { Svg_106 } from './svgs/106';
import { Svg_107 } from './svgs/107';
import { Svg_108 } from './svgs/108';
import { Svg_109 } from './svgs/109';
import { Svg_110 } from './svgs/110';
import { Svg_111 } from './svgs/111';
import { Svg_112 } from './svgs/112';
import { Svg_113 } from './svgs/113';
import { Svg_114 } from './svgs/114';
import { Svg_115 } from './svgs/115';
import { Svg_116 } from './svgs/116';
import { Svg_117 } from './svgs/117';
import { Svg_118 } from './svgs/118';
import { Svg_119 } from './svgs/119';
import { Svg_120 } from './svgs/120';
import { Svg_121 } from './svgs/121';
import { Svg_122 } from './svgs/122';
import { Svg_123 } from './svgs/123';
import { Svg_124 } from './svgs/124';
import { Svg_125 } from './svgs/125';
import { Svg_126 } from './svgs/126';
import { Svg_127 } from './svgs/127';
import { Svg_128 } from './svgs/128';
import { Svg_129 } from './svgs/129';
import { Svg_130 } from './svgs/130';
import { Svg_131 } from './svgs/131';
import { Svg_132 } from './svgs/132';
import { Svg_133 } from './svgs/133';
import { Svg_134 } from './svgs/134';

const svg_dict_icon = [
  {
    id: 1,
    clicked: false,
    icon: (<Svg_001 />),
    file: '/files_icon_download/001_dollar.svg'
  },
  {
    id: 2,
    clicked: false,
    icon: (<Svg_002 />),
    file: '/files_icon_download/002_email.svg'
  },
  {
    id: 3,
    clicked: false,
    icon: (<Svg_003 />),
    file: '/files_icon_download/003_clipboard.svg'
  },
  {
    id: 4,
    clicked: false,
    icon: (<Svg_004 />),
    file: '/files_icon_download/004_wallet.svg'
  },
  {
    id: 5,
    clicked: false,
    icon: (<Svg_005 />),
    file: '/files_icon_download/005_address.svg'
  },
  {
    id: 6,
    clicked: false,
    icon: (<Svg_006 />),
    file: '/files_icon_download/006_coins.svg'
  },
  {
    id: 7,
    clicked: false,
    icon: (<Svg_007 />),
    file: '/files_icon_download/007_bank.svg'
  },
  {
    id: 8,
    clicked: false,
    icon: (<Svg_008 />),
    file: '/files_icon_download/008_reading.svg'
  },
  {
    id: 9,
    clicked: false,
    icon: (<Svg_009 />),
    file: '/files_icon_download/009_donut.svg'
  },
  {
    id: 10,
    clicked: false,
    icon: (<Svg_010 />),
    file: '/files_icon_download/010_money.svg'
  },
  {
    id: 11,
    clicked: false,
    icon: (<Svg_011 />),
    file: '/files_icon_download/011_education.svg'
  },
  {
    id: 12,
    clicked: false,
    icon: (<Svg_012 />),
    file: '/files_icon_download/012_online.svg'
  },
  {
    id: 13,
    clicked: false,
    icon: (<Svg_013 />),
    file: '/files_icon_download/013_dollar.svg'
  },
  {
    id: 14,
    clicked: false,
    icon: (<Svg_014 />),
    file: '/files_icon_download/014_folder.svg'
  },
  {
    id: 15,
    clicked: false,
    icon: (<Svg_015 />),
    file: '/files_icon_download/015_link.svg'
  },
  {
    id: 16,
    clicked: false,
    icon: (<Svg_016 />),
    file: '/files_icon_download/016_box.svg'
  },
  {
    id: 17,
    clicked: false,
    icon: (<Svg_017 />),
    file: '/files_icon_download/017_invoice.svg'
  },
  {
    id: 18,
    clicked: false,
    icon: (<Svg_018 />),
    file: '/files_icon_download/018_highlight.svg'
  },
  {
    id: 19,
    clicked: false,
    icon: (<Svg_019 />),
    file: '/files_icon_download/019_location.svg'
  },
  {
    id: 20,
    clicked: false,
    icon: (<Svg_020 />),
    file: '/files_icon_download/020_profit.svg'
  },
  {
    id: 21,
    clicked: false,
    icon: (<Svg_021 />),
    file: '/files_icon_download/021_calendar.svg'
  },
  {
    id: 22,
    clicked: false,
    icon: (<Svg_022 />),
    file: '/files_icon_download/022_coin.svg'
  },
  {
    id: 23,
    clicked: false,
    icon: (<Svg_023 />),
    file: '/files_icon_download/023_money.svg'
  },
  {
    id: 24,
    clicked: false,
    icon: (<Svg_024 />),
    file: '/files_icon_download/024_mr.svg'
  },
  {
    id: 25,
    clicked: false,
    icon: (<Svg_025 />),
    file: '/files_icon_download/025_banking.svg'
  },
  {
    id: 26,
    clicked: false,
    icon: (<Svg_026 />),
    file: '/files_icon_download/026_dollar.svg'
  },
  {
    id: 27,
    clicked: false,
    icon: (<Svg_027 />),
    file: '/files_icon_download/027_certificate.svg'
  },
  {
    id: 28,
    clicked: false,
    icon: (<Svg_028 />),
    file: '/files_icon_download/028_secure.svg'
  },
  {
    id: 29,
    clicked: false,
    icon: (<Svg_029 />),
    file: '/files_icon_download/029_skills.svg'
  },
  {
    id: 30,
    clicked: false,
    icon: (<Svg_030 />),
    file: '/files_icon_download/030_coins.svg'
  },
  {
    id: 31,
    clicked: false,
    icon: (<Svg_031 />),
    file: '/files_icon_download/031_atm.svg'
  },
  {
    id: 32,
    clicked: false,
    icon: (<Svg_032 />),
    file: '/files_icon_download/032_website.svg'
  },
  {
    id: 33,
    clicked: false,
    icon: (<Svg_033 />),
    file: '/files_icon_download/033_award.svg'
  },
  {
    id: 34,
    clicked: false,
    icon: (<Svg_034 />),
    file: '/files_icon_download/034_credit.svg'
  },
  {
    id: 35,
    clicked: false,
    icon: (<Svg_035 />),
    file: '/files_icon_download/035_job.svg'
  },
  {
    id: 36,
    clicked: false,
    icon: (<Svg_036 />),
    file: '/files_icon_download/036_fax.svg'
  },
  {
    id: 37,
    clicked: false,
    icon: (<Svg_037 />),
    file: '/files_icon_download/037_purse.svg'
  },
  {
    id: 38,
    clicked: false,
    icon: (<Svg_038 />),
    file: '/files_icon_download/038_calculator.svg'
  },
  {
    id: 39,
    clicked: false,
    icon: (<Svg_039 />),
    file: '/files_icon_download/039_mrs.svg'
  },
  {
    id: 40,
    clicked: false,
    icon: (<Svg_040 />),
    file: '/files_icon_download/040_briefcase.svg'
  },
  {
    id: 41,
    clicked: false,
    icon: (<Svg_041 />),
    file: '/files_icon_download/041_laptop.svg'
  },
  {
    id: 42,
    clicked: false,
    icon: (<Svg_042 />),
    file: '/files_icon_download/042_goal.svg'
  },
  {
    id: 43,
    clicked: false,
    icon: (<Svg_043 />),
    file: '/files_icon_download/043_resume.svg'
  },
  {
    id: 44,
    clicked: false,
    icon: (<Svg_044 />),
    file: '/files_icon_download/044_money.svg'
  },
  {
    id: 45,
    clicked: false,
    icon: (<Svg_045 />),
    file: '/files_icon_download/045_telephone.svg'
  },
  {
    id: 46,
    clicked: false,
    icon: (<Svg_046 />),
    file: '/files_icon_download/046_career.svg'
  },
  {
    id: 47,
    clicked: false,
    icon: (<Svg_047 />),
    file: '/files_icon_download/047_transfer.svg'
  },
  {
    id: 48,
    clicked: false,
    icon: (<Svg_048 />),
    file: '/files_icon_download/048_school.svg'
  },
  {
    id: 49,
    clicked: false,
    icon: (<Svg_049 />),
    file: '/files_icon_download/049_bitcoin.svg'
  },
  {
    id: 50,
    clicked: false,
    icon: (<Svg_050 />),
    file: '/files_icon_download/050_movie.svg'
  },
  {
    id: 51,
    clicked: false,
    icon: (<Svg_051 />),
    file: '/files_icon_download/051_growth.svg'
  },
  {
    id: 52,
    clicked: false,
    icon: (<Svg_052 />),
    file: '/files_icon_download/052_volunteering.svg'
  },
  {
    id: 53,
    clicked: false,
    icon: (<Svg_053 />),
    file: '/files_icon_download/053_register.svg'
  },
  {
    id: 54,
    clicked: false,
    icon: (<Svg_054 />),
    file: '/files_icon_download/054_check.svg'
  },
  {
    id: 55,
    clicked: false,
    icon: (<Svg_055 />),
    file: '/files_icon_download/055_agenda.svg'
  },
  {
    id: 56,
    clicked: false,
    icon: (<Svg_056 />),
    file: '/files_icon_download/056_portfolio.svg'
  },
  {
    id: 57,
    clicked: false,
    icon: (<Svg_057 />),
    file: '/files_icon_download/057_investment.svg'
  },
  {
    id: 58,
    clicked: false,
    icon: (<Svg_058 />),
    file: '/files_icon_download/058_business.svg'
  },
  {
    id: 59,
    clicked: false,
    icon: (<Svg_059 />),
    file: '/files_icon_download/059_recommendation.svg'
  },
  {
    id: 60,
    clicked: false,
    icon: (<Svg_060 />),
    file: '/files_icon_download/060_internship.svg'
  },
  {
    id: 61,
    clicked: false,
    icon: (<Svg_061 />),
    file: '/files_icon_download/061_career.svg'
  },
  {
    id: 62,
    clicked: false,
    icon: (<Svg_062 />),
    file: '/files_icon_download/062_willing.svg'
  },
  {
    id: 63,
    clicked: false,
    icon: (<Svg_063 />),
    file: '/files_icon_download/063_hiring.svg'
  },
  {
    id: 64,
    clicked: false,
    icon: (<Svg_064 />),
    file: '/files_icon_download/064_driving.svg'
  },
  {
    id: 65,
    clicked: false,
    icon: (<Svg_065 />),
    file: '/files_icon_download/065_publications.svg'
  },
  {
    id: 66,
    clicked: false,
    icon: (<Svg_066 />),
    file: '/files_icon_download/066_profile.svg'
  },
  {
    id: 67,
    clicked: false,
    icon: (<Svg_067 />),
    file: '/files_icon_download/067_computer.svg'
  },
  {
    id: 68,
    clicked: false,
    icon: (<Svg_068 />),
    file: '/files_icon_download/068_goals.svg'
  },
  {
    id: 69,
    clicked: false,
    icon: (<Svg_069 />),
    file: '/files_icon_download/069_training.svg'
  },
  {
    id: 70,
    clicked: false,
    icon: (<Svg_070 />),
    file: '/files_icon_download/070_salary.svg'
  },
  {
    id: 71,
    clicked: false,
    icon: (<Svg_071 />),
    file: '/files_icon_download/071_music.svg'
  },
  {
    id: 72,
    clicked: false,
    icon: (<Svg_072 />),
    file: '/files_icon_download/072_achievement.svg'
  },
  {
    id: 73,
    clicked: false,
    icon: (<Svg_073 />),
    file: '/files_icon_download/003_clipboard.svg'
  },
  {
    id: 74,
    clicked: false,
    icon: (<Svg_074 />),
    file: '/files_icon_download/074_website.svg'
  },
  {
    id: 75,
    clicked: false,
    icon: (<Svg_075 />),
    file: '/files_icon_download/075_stamp.svg'
  },
  {
    id: 76,
    clicked: false,
    icon: (<Svg_076 />),
    file: '/files_icon_download/076.svg'
  },
  {
    id: 77,
    clicked: false,
    icon: (<Svg_077 />),
    file: '/files_icon_download/077.svg'
  },
  {
    id: 78,
    clicked: false,
    icon: (<Svg_078 />),
    file: '/files_icon_download/078.svg'
  },
  {
    id: 79,
    clicked: false,
    icon: (<Svg_079 />),
    file: '/files_icon_download/079.svg'
  },
  {
    id: 80,
    clicked: false,
    icon: (<Svg_080 />),
    file: '/files_icon_download/080.svg'
  },
  {
    id: 81,
    clicked: false,
    icon: (<Svg_081 />),
    file: '/files_icon_download/081.svg'
  },
  {
    id: 82,
    clicked: false,
    icon: (<Svg_082 />),
    file: '/files_icon_download/082.svg'
  },
  {
    id: 83,
    clicked: false,
    icon: (<Svg_083 />),
    file: '/files_icon_download/083.svg'
  },
  {
    id: 84,
    clicked: false,
    icon: (<Svg_084 />),
    file: '/files_icon_download/084.svg'
  },
  {
    id: 85,
    clicked: false,
    icon: (<Svg_085 />),
    file: '/files_icon_download/085.svg'
  },
  {
    id: 86,
    clicked: false,
    icon: (<Svg_086 />),
    file: '/files_icon_download/086.svg'
  },
  {
    id: 87,
    clicked: false,
    icon: (<Svg_087 />),
    file: '/files_icon_download/087.svg'
  },
  {
    id: 88,
    clicked: false,
    icon: (<Svg_088 />),
    file: '/files_icon_download/088.svg'
  },
  {
    id: 89,
    clicked: false,
    icon: (<Svg_089 />),
    file: '/files_icon_download/089.svg'
  },
  {
    id: 90,
    clicked: false,
    icon: (<Svg_090 />),
    file: '/files_icon_download/090.svg'
  },
  {
    id: 91,
    clicked: false,
    icon: (<Svg_091 />),
    file: '/files_icon_download/091.svg'
  },
  {
    id: 92,
    clicked: false,
    icon: (<Svg_092 />),
    file: '/files_icon_download/092.svg'
  },
  {
    id: 93,
    clicked: false,
    icon: (<Svg_093 />),
    file: '/files_icon_download/093.svg'
  },
  {
    id: 94,
    clicked: false,
    icon: (<Svg_094 />),
    file: '/files_icon_download/094.svg'
  },
  {
    id: 95,
    clicked: false,
    icon: (<Svg_095 />),
    file: '/files_icon_download/095.svg'
  },
  {
    id: 96,
    clicked: false,
    icon: (<Svg_096 />),
    file: '/files_icon_download/096.svg'
  },
  {
    id: 97,
    clicked: false,
    icon: (<Svg_097 />),
    file: '/files_icon_download/097.svg'
  },
  {
    id: 98,
    clicked: false,
    icon: (<Svg_098 />),
    file: '/files_icon_download/098.svg'
  },
  {
    id: 99,
    clicked: false,
    icon: (<Svg_099 />),
    file: '/files_icon_download/099.svg'
  },
  {
    id: 100,
    clicked: false,
    icon: (<Svg_100 />),
    file: '/files_icon_download/100.svg'
  },
  {
    id: 101,
    clicked: false,
    icon: (<Svg_101 />),
    file: '/files_icon_download/101.svg'
  },
  {
    id: 102,
    clicked: false,
    icon: (<Svg_102 />),
    file: '/files_icon_download/102.svg'
  },
  {
    id: 103,
    clicked: false,
    icon: (<Svg_103 />),
    file: '/files_icon_download/103.svg'
  },
  {
    id: 104,
    clicked: false,
    icon: (<Svg_104 />),
    file: '/files_icon_download/104.svg'
  },
  {
    id: 105,
    clicked: false,
    icon: (<Svg_105 />),
    file: '/files_icon_download/105.svg'
  },
  {
    id: 106,
    clicked: false,
    icon: (<Svg_106 />),
    file: '/files_icon_download/106.svg'
  },
  {
    id: 107,
    clicked: false,
    icon: (<Svg_107 />),
    file: '/files_icon_download/107.svg'
  },
  {
    id: 108,
    clicked: false,
    icon: (<Svg_108 />),
    file: '/files_icon_download/108.svg'
  },
  {
    id: 109,
    clicked: false,
    icon: (<Svg_109 />),
    file: '/files_icon_download/109.svg'
  },
  {
    id: 110,
    clicked: false,
    icon: (<Svg_110 />),
    file: '/files_icon_download/110.svg'
  },
  {
    id: 111,
    clicked: false,
    icon: (<Svg_111 />),
    file: '/files_icon_download/111.svg'
  },
  {
    id: 112,
    clicked: false,
    icon: (<Svg_112 />),
    file: '/files_icon_download/112.svg'
  },
  {
    id: 113,
    clicked: false,
    icon: (<Svg_113 />),
    file: '/files_icon_download/113.svg'
  },
  {
    id: 114,
    clicked: false,
    icon: (<Svg_114 />),
    file: '/files_icon_download/114.svg'
  },
  {
    id: 115,
    clicked: false,
    icon: (<Svg_115 />),
    file: '/files_icon_download/115.svg'
  },
  {
    id: 116,
    clicked: false,
    icon: (<Svg_116 />),
    file: '/files_icon_download/116.svg'
  },
  {
    id: 117,
    clicked: false,
    icon: (<Svg_117 />),
    file: '/files_icon_download/117.svg'
  },
  {
    id: 118,
    clicked: false,
    icon: (<Svg_118 />),
    file: '/files_icon_download/118.svg'
  },
  {
    id: 119,
    clicked: false,
    icon: (<Svg_119 />),
    file: '/files_icon_download/119.svg'
  },
  {
    id: 120,
    clicked: false,
    icon: (<Svg_120 />),
    file: '/files_icon_download/120.svg'
  },
  {
    id: 121,
    clicked: false,
    icon: (<Svg_121 />),
    file: '/files_icon_download/121.svg'
  },
  {
    id: 122,
    clicked: false,
    icon: (<Svg_122 />),
    file: '/files_icon_download/122.svg'
  },
  {
    id: 123,
    clicked: false,
    icon: (<Svg_123 />),
    file: '/files_icon_download/123.svg'
  },
  {
    id: 124,
    clicked: false,
    icon: (<Svg_124 />),
    file: '/files_icon_download/124.svg'
  },
  {
    id: 125,
    clicked: false,
    icon: (<Svg_125 />),
    file: '/files_icon_download/125.svg'
  },
  {
    id: 126,
    clicked: false,
    icon: (<Svg_126 />),
    file: '/files_icon_download/126.svg'
  },
  {
    id: 127,
    clicked: false,
    icon: (<Svg_127 />),
    file: '/files_icon_download/127.svg'
  },
  {
    id: 128,
    clicked: false,
    icon: (<Svg_128 />),
    file: '/files_icon_download/128.svg'
  },
  {
    id: 129,
    clicked: false,
    icon: (<Svg_129 />),
    file: '/files_icon_download/129.svg'
  },
  {
    id: 130,
    clicked: false,
    icon: (<Svg_130 />),
    file: '/files_icon_download/130.svg'
  },
  {
    id: 131,
    clicked: false,
    icon: (<Svg_131 />),
    file: '/files_icon_download/131.svg'
  },
  {
    id: 132,
    clicked: false,
    icon: (<Svg_132 />),
    file: '/files_icon_download/132.svg'
  },
  {
    id: 133,
    clicked: false,
    icon: (<Svg_133 />),
    file: '/files_icon_download/133.svg'
  },
  {
    id: 134,
    clicked: false,
    icon: (<Svg_134 />),
    file: '/files_icon_download/134.svg'
  },
]

interface IProps {
  errors: any;
  name: string;
  label: string;
  register: any;
  getDados?: any;
  formName?: string;
  tooltip?: string;
  required: boolean;
  defaultValue?: string;
  downloadName?: string;
  setValue: (e: any) => void;
  accept: "image/*" | ".pdf" | ".svg" | ".docx";
}

export const IconesModal: React.FC<IProps> = ({
  name,
  label,
  tooltip,
  required,
  formName,
  register,
  setValue,
  defaultValue,
  downloadName,
}) => {
  return (
    <Container>
      <div className="title_wrapper_textfield">
        <ToolTipWrapper
          name={name}
          label={label}
          formName={formName}
          tooltip={tooltip}
          required={required}
          register={register}
          value={defaultValue}
        />
      </div>
      <div className="file-input">
        <IconesWrapper setValue={(e) => setValue(e)} downloadName={downloadName} />
      </div>
    </Container>
  )
}

type TooltipWrapperProps = {
  name?: string,
  register?: any,
  value?: string,
  local?: string,
  label?: string,
  tooltip?: string,
  required?: boolean,
  formName?: string,
  hiddeInput?: boolean,
}

const ToolTipWrapper = ({
  name,
  label,
  value,
  formName,
  tooltip,
  required,
  register,
}: TooltipWrapperProps) => {

  const router = useRouter();
  const [epl, setEpl] = useState<boolean>(false);

  useEffect(() => {
    if (!router.isReady) return
    if (!router.query.id) return
    setEpl(router.asPath.includes('epl') && router.asPath.includes('dashboard/aprovacao_planos'));
  }, [router])

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ display: 'flex', alignItems: 'center' }} className="interFont">
        <p>{label}</p>
        <span>
          {required ? '*' : ''}
        </span>
      </label>
      {!epl && <>
        {tooltip && tooltip?.length > 0 && (
          <Tooltip arrow title={tooltip}>
            <div>
              <InfoIncon />
            </div>
          </Tooltip>
        )}
      </>
      }
      {epl && (
        <CondiserationWrapper
          name={name}
          label={label}
          value={value}
          formName={formName}
          register={register}
        />
      )}
    </div>
  )

}

const IconesWrapper = ({
  name,
  setValue,
  downloadName,
}: {
  name?: string,
  register?: any,
  label?: string,
  value?: string,
  downloadName?: string;
  setValue: (e: any) => void;
}) => {

  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState<boolean>(false);
  const { DeleteFileIcon } = new PlansService()

  const handleClose = () => {
    setOpen(false);
  };

  const [blob, setBlob] = useState<File>()
  const salvar = () => {
    setValue(blob);
    handleClose();
  }

  useEffect(() => {
    if (!router.isReady) return
    setPreview(router.asPath.includes('preview'));
  }, [router]);

  const [icons, setIcons] = useState(svg_dict_icon);

  const handleIconClick = async (id: any) => {
    // Primeiro, encontre o ícone clicado usando o estado atual
    const clickedIcon = icons.find((icon) => icon.id === id) as any;

    if (clickedIcon) {
      // Atualize o estado dos ícones
      setIcons((prevIcons) =>
        prevIcons.map((item) =>
          item.id === id
            ? { ...item, clicked: true }
            : { ...item, clicked: false }
        )
      );

      // Realiza a requisição para obter o arquivo do ícone clicado
      const response = await fetch(clickedIcon.file);
      const blob = await response.blob();

      const fileName = clickedIcon.file.split('/').pop(); // Nome do arquivo
      const file = new File([blob], fileName, { type: blob.type });

      setBlob(file); // Define o arquivo blob no estado
    }
  };

  const deleteFile = () => {
    DeleteFileIcon({ fileName: downloadName, fileType: 'icone_plano', planId: router.query.id })
  }


  return (
    <>
      {!downloadName && (
        <label className={preview ? 'file-input__label_preview' : 'file-input__label'} htmlFor={"file-input" + name} onClick={() => { if (!preview) setOpen(true) }}>
          <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.00610352 9.1875C0.00610352 7.56305 0.651414 6.00513 1.80007 4.85647C2.94873 3.70781 4.50665 3.0625 6.1311 3.0625H42.8811C44.5056 3.0625 46.0635 3.70781 47.2121 4.85647C48.3608 6.00513 49.0061 7.56305 49.0061 9.1875V39.8125C49.0061 41.437 48.3608 42.9949 47.2121 44.1435C46.0635 45.2922 44.5056 45.9375 42.8811 45.9375H6.1311C4.50665 45.9375 2.94873 45.2922 1.80007 44.1435C0.651414 42.9949 0.00610352 41.437 0.00610352 39.8125V9.1875ZM3.0686 36.75V39.8125C3.0686 40.6247 3.39126 41.4037 3.96559 41.978C4.53992 42.5523 5.31888 42.875 6.1311 42.875H42.8811C43.6933 42.875 44.4723 42.5523 45.0466 41.978C45.6209 41.4037 45.9436 40.6247 45.9436 39.8125V29.0938L34.3765 23.1311C34.0893 22.9872 33.7642 22.9373 33.4471 22.9884C33.1299 23.0395 32.8369 23.1891 32.6095 23.4159L21.2476 34.7778L13.1014 29.351C12.8072 29.1552 12.4544 29.0671 12.1028 29.1017C11.7511 29.1363 11.4223 29.2915 11.172 29.5409L3.0686 36.75ZM18.3811 16.8438C18.3811 15.6254 17.8971 14.457 17.0356 13.5955C16.1741 12.734 15.0057 12.25 13.7874 12.25C12.569 12.25 11.4006 12.734 10.5391 13.5955C9.67759 14.457 9.1936 15.6254 9.1936 16.8438C9.1936 18.0621 9.67759 19.2305 10.5391 20.092C11.4006 20.9535 12.569 21.4375 13.7874 21.4375C15.0057 21.4375 16.1741 20.9535 17.0356 20.092C17.8971 19.2305 18.3811 18.0621 18.3811 16.8438Z" fill="#818181" />
          </svg>
          {blob?.name && (<span>{blob?.name}</span>)}
          {!blob?.name && (<span>Selecionar ícone do plano</span>)}
          {blob?.name && (
            <svg onClick={() => setBlob({} as any)} style={{ margin: '0 0 0 2rem' }} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.755 1.12685C4.82416 0.988448 4.93048 0.872034 5.06206 0.790643C5.19364 0.709252 5.34528 0.666098 5.5 0.666016H10.5C10.6547 0.666098 10.8064 0.709252 10.9379 0.790643C11.0695 0.872034 11.1758 0.988448 11.245 1.12685L12.6817 3.99935H14.6667C14.8877 3.99935 15.0996 4.08715 15.2559 4.24343C15.4122 4.39971 15.5 4.61167 15.5 4.83268C15.5 5.0537 15.4122 5.26566 15.2559 5.42194C15.0996 5.57822 14.8877 5.66602 14.6667 5.66602H13.8333V14.8327C13.8333 15.4957 13.5699 16.1316 13.1011 16.6004C12.6323 17.0693 11.9964 17.3327 11.3333 17.3327H4.66667C4.00363 17.3327 3.36774 17.0693 2.8989 16.6004C2.43006 16.1316 2.16667 15.4957 2.16667 14.8327V5.66602H1.33333C1.11232 5.66602 0.900358 5.57822 0.744078 5.42194C0.587797 5.26566 0.5 5.0537 0.5 4.83268C0.5 4.61167 0.587797 4.39971 0.744078 4.24343C0.900358 4.08715 1.11232 3.99935 1.33333 3.99935H3.31833L4.755 1.12685ZM9.985 2.33268L10.8183 3.99935H5.18167L6.015 2.33268H9.985ZM7.16667 8.16602C7.16667 7.945 7.07887 7.73304 6.92259 7.57676C6.76631 7.42048 6.55435 7.33268 6.33333 7.33268C6.11232 7.33268 5.90036 7.42048 5.74408 7.57676C5.5878 7.73304 5.5 7.945 5.5 8.16602V13.166C5.5 13.387 5.5878 13.599 5.74408 13.7553C5.90036 13.9116 6.11232 13.9993 6.33333 13.9993C6.55435 13.9993 6.76631 13.9116 6.92259 13.7553C7.07887 13.599 7.16667 13.387 7.16667 13.166V8.16602ZM10.5 8.16602C10.5 7.945 10.4122 7.73304 10.2559 7.57676C10.0996 7.42048 9.88768 7.33268 9.66667 7.33268C9.44565 7.33268 9.23369 7.42048 9.07741 7.57676C8.92113 7.73304 8.83333 7.945 8.83333 8.16602V13.166C8.83333 13.387 8.92113 13.599 9.07741 13.7553C9.23369 13.9116 9.44565 13.9993 9.66667 13.9993C9.88768 13.9993 10.0996 13.9116 10.2559 13.7553C10.4122 13.599 10.5 13.387 10.5 13.166V8.16602Z" fill="#EC1F1F" />
            </svg>
          )}
        </label>
      )}
      {downloadName && (
        <div>
          <a
            href={`${ACCESS.API_URL}final/download/${downloadName}`}
            style={{ color: '#004A80' }}
          >Baixar arquivo</a>
          {!preview && (
            <button onClick={deleteFile} style={{ background: 'transparent', border: 'none', marginLeft: 15 }}>
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.755 1.12685C4.82416 0.988448 4.93048 0.872034 5.06206 0.790643C5.19364 0.709252 5.34528 0.666098 5.5 0.666016H10.5C10.6547 0.666098 10.8064 0.709252 10.9379 0.790643C11.0695 0.872034 11.1758 0.988448 11.245 1.12685L12.6817 3.99935H14.6667C14.8877 3.99935 15.0996 4.08715 15.2559 4.24343C15.4122 4.39971 15.5 4.61167 15.5 4.83268C15.5 5.0537 15.4122 5.26566 15.2559 5.42194C15.0996 5.57822 14.8877 5.66602 14.6667 5.66602H13.8333V14.8327C13.8333 15.4957 13.5699 16.1316 13.1011 16.6004C12.6323 17.0693 11.9964 17.3327 11.3333 17.3327H4.66667C4.00363 17.3327 3.36774 17.0693 2.8989 16.6004C2.43006 16.1316 2.16667 15.4957 2.16667 14.8327V5.66602H1.33333C1.11232 5.66602 0.900358 5.57822 0.744078 5.42194C0.587797 5.26566 0.5 5.0537 0.5 4.83268C0.5 4.61167 0.587797 4.39971 0.744078 4.24343C0.900358 4.08715 1.11232 3.99935 1.33333 3.99935H3.31833L4.755 1.12685ZM9.985 2.33268L10.8183 3.99935H5.18167L6.015 2.33268H9.985ZM7.16667 8.16602C7.16667 7.945 7.07887 7.73304 6.92259 7.57676C6.76631 7.42048 6.55435 7.33268 6.33333 7.33268C6.11232 7.33268 5.90036 7.42048 5.74408 7.57676C5.5878 7.73304 5.5 7.945 5.5 8.16602V13.166C5.5 13.387 5.5878 13.599 5.74408 13.7553C5.90036 13.9116 6.11232 13.9993 6.33333 13.9993C6.55435 13.9993 6.76631 13.9116 6.92259 13.7553C7.07887 13.599 7.16667 13.387 7.16667 13.166V8.16602ZM10.5 8.16602C10.5 7.945 10.4122 7.73304 10.2559 7.57676C10.0996 7.42048 9.88768 7.33268 9.66667 7.33268C9.44565 7.33268 9.23369 7.42048 9.07741 7.57676C8.92113 7.73304 8.83333 7.945 8.83333 8.16602V13.166C8.83333 13.387 8.92113 13.599 9.07741 13.7553C9.23369 13.9116 9.44565 13.9993 9.66667 13.9993C9.88768 13.9993 10.0996 13.9116 10.2559 13.7553C10.4122 13.599 10.5 13.387 10.5 13.166V8.16602Z" fill="#EC1F1F" />
              </svg>
            </button>
          )}
        </div>
      )}

      <Dialog
        sx={{ marginTop: '4rem' }}
        open={open}
        scroll='paper'
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title">
          Ícones
        </DialogTitle>
        <DialogContent>
          <p style={{ marginBottom: '1rem' }}>
            Selecione um ícone
          </p>
          <ListIconWrapper>
            {icons.map(item => (
              <SvgContainer
                key={item.id}
                clicked={item.clicked}
                onClick={() => handleIconClick(item.id)}
              >
                {item.icon}
              </SvgContainer>
            ))}
          </ListIconWrapper>
        </DialogContent>
        <DialogActions>
          <ButtonWrapper>
            <button className="cancel" onClick={() => handleClose()}>
              <p>Cancelar</p>
            </button>
            <button onClick={() => salvar()}>
              <p>Salvar</p>
            </button>
          </ButtonWrapper>
        </DialogActions>
      </Dialog>
    </>
  )
}

const CondiserationWrapper = ({
  name,
  value,
  label,
  formName,
  register,
}: {
  name?: string,
  register?: any,
  label?: string,
  value?: string,
  formName?: string
}) => {

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <a className="consideration-modal" onClick={() => { setOpen(true) }}>
        <ConsideracaoIcon />
      </a>
      <ConsiderationModal
        open={open}
        name={name}
        label={label}
        formName={formName}
        value={value}
        register={register}
        handleClose={handleClose}
      />
    </>
  )
}